module.exports = __webpack_public_path__ + "static/img/level_off.c88b765c.webp";